import { createContext, useContext } from "react";
import { ILandingData } from "./types";

const initialState: ILandingData = {
  description: "",
  metaDescription: "",
  metaTitle: "",
  title: "",
  noIndex: false
};
const LandingTitleContext = createContext<ILandingData>(initialState);

const useLandingTitle = () => useContext(LandingTitleContext);

export { LandingTitleContext, useLandingTitle };
